var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.1425 8.46326H8.46289V37.8355H36.1425V8.46326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23 0C10.2554 0 0 10.355 0 23C0 35.7446 10.2554 46 23 46C35.7446 46 46 35.645 46 23C46 10.355 35.7446 0 23 0ZM25.3896 34.9481C25.0909 35.4459 24.7922 36.0433 24.0952 36.0433C23.4978 36.0433 23 35.4459 22.7013 34.9481L10.9524 13.4416C10.6537 12.8442 10.355 12.2468 10.2554 11.5498C10.1558 10.4545 10.7532 9.75758 11.8485 9.75758C14.5368 9.75758 17.2251 9.75758 19.9134 9.75758C21.0087 9.75758 21.8052 10.2554 22.4026 11.3506C23.697 13.9394 24.5931 16.1299 26.2857 18.5195C30.2684 23 34.1515 18.5195 35.7446 16.7273L25.3896 34.9481Z",
    fill: "#9247FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobLogo);
export default __webpack_public_path__ + "static/media/mobLogo.ba020d3ce780db44a43c35021f2b373c.svg";
export { ForwardRef as ReactComponent };